/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Syncing_And_Generating_CommitInputs */

const en_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performing sync and generating new commit... please wait.`)
};

const fr_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation et génération d’un nouveau commit... veuillez patienter.`)
};

const de_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierung wird durchgeführt und ein neuer Commit generiert... bitte warten.`)
};

const it_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esecuzione della sincronizzazione e generazione di un nuovo commit... attendere.`)
};

const ru_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняется синхронизация и генерация нового коммита... пожалуйста, подождите.`)
};

const es_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizando sincronización y generando nueva confirmación... por favor espere.`)
};

const zh_cn2_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在执行同步并生成新的提交……请稍候。`)
};

const ja_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期を実行して新しいコミットを生成しています...お待ちください。`)
};

const hi_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़ेशन किया जा रहा है और नया कमिट जनरेट किया जा रहा है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_team_sync_status_syncing_and_generating_commit = /** @type {(inputs: Team_Sync_Status_Syncing_And_Generating_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando e gerando novo commit... aguarde.`)
};

/**
* | output |
* | --- |
* | "Performing sync and generating new commit... please wait." |
*
* @param {Team_Sync_Status_Syncing_And_Generating_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_syncing_and_generating_commit = /** @type {((inputs?: Team_Sync_Status_Syncing_And_Generating_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Syncing_And_Generating_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "de") return de_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "it") return it_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "ru") return ru_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "es") return es_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "ja") return ja_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "hi") return hi_team_sync_status_syncing_and_generating_commit(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_status_syncing_and_generating_commit(inputs)
	return en_team_sync_status_syncing_and_generating_commit(inputs)
});